import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { BulkOrderService } from '../../../../SGRE-custom/bulk-order-page/services/bulk-order.service';
import { CmsParagraphComponent } from '@spartacus/core';

@Component({
    selector: 'app-bulkorder-download-paragraph',
    templateUrl: './bulkorder-download-paragraph.component.html',
    styleUrl: './bulkorder-download-paragraph.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BulkorderDownloadParagraphComponent {

  /** Old Implementation
  public userRoles: any[];
  role: string;
  public componentData: any; */

  /** OOTB Implementation */
  @Input() data: Observable<CmsParagraphComponent>;
  currentpage$: Observable<number>;

  constructor(
    private bulkservice: BulkOrderService,
  ) { }

  /** OOTB Implementation */
  ngOnInit(): void {
    this.getCurrentPage();
  }

  getCurrentPage(): void {
    this.currentpage$ = this.bulkservice.getNextValue();
  }

  /** Old Implementation
  ngOnInit(): void {
    this.currentpage$ = this.bulkservice.isNext$;
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  } */
}
